// extracted by mini-css-extract-plugin
export default {"vendorWrapper":"Vendor_vendorWrapper__3hEGv","title":"Vendor_title__TIyAB"};